import React, { createContext, useReducer } from 'react'

import { merge } from 'lodash'

import { freeze } from 'utils/dom'

import { facilityLabelData } from 'common/Location/reducer'

const defaultState = freeze({
  skus: [],
  campaign: '_',
  key: '',
  user: '',
  note: '',
  card: undefined,
  orgId: undefined,
  org: {},
  finished: false
})

export const R_START = {
  SET_ORG: 12,
  MERGE: 30
}

export function doesOrgHaveAddress(org) {
  const address = org?.address

  if (typeof address !== 'object') return false

  const { city, postal, state, street } = address

  return [city, postal, state, street].every(
    (val) => typeof val === 'string' && val.trim().length > 0
  )
}

export function normalizeOrg(org) {
  const defaultAddress = { street: '', city: '', state: '', postal: '' }
  const address = org?.data?.find(({ type }) => type === 'companyaddr')?.value
    ?.value

  if (typeof address !== 'object') {
    return { ...org, address: defaultAddress }
  }

  return { ...org, address: merge(defaultAddress, address) }
}

function reducer(state, { type, value, ...args }) {
  switch (type) {
    case R_START.SET_ORG:
      const { org } = value
      return { ...state, orgId: org.id, org: normalizeOrg(org) }
    case R_START.MERGE:
      return { ...state, ...value }
    default:
      throw new Error(`GetStartedReducer - no such action.type: ${type}!`)
  }
}

export const GetStartedContext = createContext(null)
export function GetStartedProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, defaultState)
  return (
    <GetStartedContext.Provider value={[state, dispatch]}>
      {children}
    </GetStartedContext.Provider>
  )
}

export default GetStartedContext
export { facilityLabelData }
